import * as React from 'react';
import * as Modal from 'react-modal';
import { isEmpty } from 'lodash';

import { createApiClient } from '../../services/ApiClient';

import Autocomplete from '../controls/CompanyInput';
import Alert from '../../modules/metajson-sub/src/libs/controls/components/Alert';

interface State {
  open: boolean;
  inn: string;
  error?: string;
  disabledSearch: boolean;
  inputs: Object;
  options: any;
}

interface Props {
  onSend: (id: string, company: object) => void;
  programUid: string;
}

export class CompanyInfo extends React.Component<Props, State> {
  public refs: { [key: string]: HTMLInputElement };

  constructor() {
    // @ts-ignore
    super();
    this.state = {
      options: [],
      open: false,
      inn: '',
      disabledSearch: true,
      inputs: {},
    };
    this.onSearch = this.onSearch.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onClose = () => this.setState({ open: false });

  onChangeInput = ({ target: { name, value } }) => {
    this.setState({ inputs: { ...this.state.inputs, [name]: value } });
  };

  onSearch(value) {
    const self = this;
    const api = createApiClient();
    // this.setState({isLoading: true});

    api.suggest(value, {
      success: (data) => {
        self.setState({
          options: data.map((t: any) => {
            const short = (t.data && t.data.opf && t.data.opf.short) || '';
            const full = (t.data && t.data.name && t.data.name.full) || '';
            return { ...t, value: short + ' ' + full };
          }),
          // isLoading: false,
          // value
        });
      },
      error: (status) => {
        // this.setState({ isLoading: false });
        this.onErrorSelected();
      },
    });
  }

  onChange(inn: string) {
    const api = createApiClient();

    if (!isEmpty(inn)) {
      const company = this.state.options.find(function (item, index, array) {
        if (item.data && item.data.inn === inn) {
          return true;
        }
      });

      if (company) {
        this.setState({
          error: null,
          inputs: {
            inn: company.data.inn,
            ogrn: company.data.ogrn,
            kpp: company.data.kpp,
            address: company.data.address.value,
            companyName:
              company.data.name && company.data.name.full_with_opf
                ? company.data.name.full_with_opf
                : '',
          },
        });
      }
      // api.companyInfo(inn,{
      //     success:(data)=>{
      //         this.setState({ error: null, inputs: {...data}})
      //     },
      //     error: (e) =>{
      //                            this.setState({
      //             error: "Не удалось найти ОРН компаний из участников Сколково",
      //             inn:"",
      //             inputs: {}
      //         });

      //         this.setState({
      //             error: "Не удалось найти ОРН компаний из участников Сколково",
      //             inn:"",
      //             inputs: {}
      //         });
      //     }
      // });
    } else {
      this.setState({ inn: '', inputs: {}, error: null });
    }
  }

  show() {
    this.setState({
      error: null,
      inn: '',
      open: true,
      inputs: {},
      disabledSearch: true,
    });
  }

  onClick() {
    this.props.onSend(this.props.programUid, this.state.inputs);
    this.setState({ error: null });
  }

  onErrorSelected = () => {
    this.setState({
      disabledSearch: false,
      error:
        'В данный момент сервис дадата не работает заполните данные о компаний от руки',
    });
  };

  enabledActionBtn = () => {
    const { inputs } = this.state;
    const state = ['companyName', 'kpp', 'ogrn', 'inn'].every(
      (name) => !isEmpty(inputs[name]),
    );
    return !state;
  };

  render() {
    const notSpinBox = `input::-webkit-outer-spin-button, 
                            input::-webkit-inner-spin-button {
                                -webkit-appearance: none; margin: 0;
                            } 
                            input[type=number] { 
                                -moz-appearance:textfield; 
                            }`;
    return (
      <Modal
        isOpen={this.state.open}
        ariaHideApp={false}
        className="react-bs-insert-modal modal-dialog"
        contentLabel="Modal"
        style={{ overlay: { backgroundColor: 'rgba(0,0,0,.25)' } }}
      >
        <style>{notSpinBox}</style>
        <div className="modal-content react-bs-table-insert-modal">
          <div className="modal-header">
            <button type="button" className="close" onClick={this.onClose}>
              <span aria-hidden="true">×</span>
            </button>
            <h4 className="modal-title">Компания</h4>
          </div>
          <div className="modal-body">
            {!isEmpty(this.state.error) && <Alert>{this.state.error}</Alert>}
            {this.state.disabledSearch && (
              <div className="from-group">
                <label>Поиск компаний</label>
                <div className="input-group" style={{ width: '100%' }}>
                  <Autocomplete
                    onSelect={this.onChange}
                    onSearch={this.onSearch}
                    options={this.state.options}
                  />
                </div>
                <div className="line-wrap"></div>
              </div>
            )}
            <div className="from-group">
              <label>Название компании</label>
              <input
                name="companyName"
                value={this.state.inputs['companyName'] || ''}
                type="text"
                onChange={this.onChangeInput}
                className="form-control"
              />
            </div>
            <div className="from-group">
              <label>Юридический адрес компании</label>
              <textarea
                className="form-control"
                name="address"
                value={this.state.inputs['address'] || ''}
                onChange={this.onChangeInput}
                rows={3}
              ></textarea>
            </div>
            <div className="from-group">
              <label>ИНН</label>
              <input
                name="inn"
                type="number"
                value={this.state.inputs['inn'] || ''}
                onChange={this.onChangeInput}
                className="form-control not-span-box"
              />
            </div>
            <div className="from-group">
              <label>ОГРН</label>
              <input
                name="ogrn"
                type="number"
                value={this.state.inputs['ogrn'] || ''}
                onChange={this.onChangeInput}
                className="form-control not-span-box"
              />
            </div>
            <div className="from-group">
              <label>КПП</label>
              <input
                name="kpp"
                type="number"
                value={this.state.inputs['kpp'] || ''}
                onChange={this.onChangeInput}
                className="form-control not-span-box"
              />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-default btn-secondary"
              onClick={this.onClose}
            >
              Отмена
            </button>
            <button
              type="button"
              disabled={this.enabledActionBtn()}
              className="btn btn-primary"
              onClick={this.onClick}
            >
              Продолжить
            </button>
          </div>
        </div>
      </Modal>
    );
  }
}
